module.exports = __webpack_public_path__ + "img/googleIcon.89b8839a.svg";